import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,

  state: { step: 1, submitDone: false },

  mutations: { updateField },

  actions: {},

  getters: { getField },
};



// WEBPACK FOOTER //
// ./src/store/modules/closetheloop/index.js